import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { useMediaQuery } from 'beautiful-react-hooks';


const AreasList = (props) => {
    const settings = {
        dots: false,
        slide: null,
        infinite: false,
        arrows: false,
        centerMode: true,
        centerPadding: '30px',
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: 1,
        initialSlide: 0,
        variableWidth: true,
        outerEdgeLimit: true,
        responsive: [
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    initialSlide: 0,
                }
            }
        ]
    };

    const isTablet = useMediaQuery('(max-width: 1023px)');

    const handleClick = (area, total) => {
        props.dispatch({
            type: 'SELECT_SUBJECT',
            area: area,
            total: total
        });
    };

    const computeAreas = () => {
        return Object.keys(props.survey).map((area, index) => (
            <Link key={index}
                  className={`area area--field ${props.test[area].done ? 'done' : 'active'}`}
                  to="/survey/question"
                  onClick={() => handleClick(area, props.survey[area].questions.length)}>
                <div className="area__inner">
                <span className="counter hover-visible">
                    {props.survey[area].questions.length} PYTAŃ
                </span>
                    <h3>{props.survey[area].name}</h3>
                    <button className="btn btn--secondary btn--revert hover-visible">
                        <span>{ props.testsDone ? 'Kontynuuj' : 'Zaczynamy' }</span>
                    </button>
                </div>
            </Link>
        ));
    };

    const areas = computeAreas(props);

    return(
        <div className="areas">
            { isTablet ? (
                <Slider {...settings}>
                    { areas }
                </Slider>
            ) : areas  }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        survey: state.survey,
        test: state.test,
        testsDone: state.globals.testsDone
    };
};

export default connect(mapStateToProps)(AreasList);



// WEBPACK FOOTER //
// ./sources/js/components/Areas/AreasList.js